import { FC, ReactElement, useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import React from 'react';
import { useAppSelector } from '@/hooks/useAppSelector';
import { useClerk } from '@clerk/clerk-react';

interface PrivateRouteProps {
  children: ReactElement;
  redirectTo?: string;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children, redirectTo = '/login' }) => {
  const { user, loading } = useAuth();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const location = useLocation();
  const { signOut } = useClerk();
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [shouldRedirectToLogin, setShouldRedirectToLogin] = useState(false);
  console.log('currentUser PrivateRoute', currentUser);

  useEffect(() => {
    const checkSessionPersistence = async () => {
      if (loading) return;

      if (user) {
        // Check if session should persist based on remember me preference
        const hasRememberMe = localStorage.getItem('clerkAuthSession') === 'true';
        const hasSessionAuth = sessionStorage.getItem('clerkAuthSession') === 'true';

        if (!hasRememberMe && !hasSessionAuth) {
          // User is signed in but no valid auth flag exists
          // This means they logged in without "Remember Me" and opened a new tab
          console.log('Session persistence check failed, signing out...');
          try {
            // Clear any remaining flags
            localStorage.removeItem('clerkAuthSession');
            localStorage.removeItem('rememberMe');
            sessionStorage.removeItem('clerkAuthSession');

            await signOut();
            setShouldRedirectToLogin(true);
          } catch (error) {
            console.error('Error signing out:', error);
          }
        }
      }

      setIsCheckingSession(false);
    };

    checkSessionPersistence();
  }, [user, loading, signOut]);

  // Show nothing while checking session persistence
  if (loading || isCheckingSession) {
    return null;
  }

  // Redirect to login if session persistence check failed
  if (shouldRedirectToLogin || !user) {
    return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />;
  }

  // Prevent admin users from accessing regular user routes
  if (currentUser?.roles?.includes('ADMIN')) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
